export default __webpack_public_path__ + "static/vivienda-2865e6acd487b53d57c6635ef2079b3a.png";